/**
 * jQuery
 * Hoist Jquery and Bootstrap
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

try {
    /* Hoist jQuery */
    window.$ = window.jQuery = require('jquery');

    /**
     * Next we will register the CSRF Token as a common header with Axios so that
     * all outgoing HTTP requests automatically have it attached. This is just
     * a simple convenience so we don't have to attach every token manually.
     */

    let token = document.head.querySelector('meta[name="csrf-token"]');

    if (token) {
        window.$.ajaxSetup({headers: {'X-CSRF-TOKEN': token.content}});
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }

    /* Add bootstrap */
    require('bootstrap');
} catch (e) {}

require ('./jquery.data-filter')
require ('./jquery.require-if-visible')
require ('./jquery.select-on-focus')
require ('./modal.remove')
require ('./modal.remote')
require ('./datetimepicker')
require ('./inputfile')
require ('./mask')
require ('./select2')
require ('./signature_pad')
require ('./sparkline')
require ('./validation')



// WEBPACK FOOTER //
// ./resources/js/services/jquery/index.js